import { z } from "zod";
import { adminPaginationSchema, parseAdminPagination } from "./admin-pagination";

export const adminContentSearchSchema = adminPaginationSchema.extend({
  q: z.string().trim().max(200).default(""),
});

export function parseAdminContentSearch(search: Record<string, unknown>) {
  return { ...parseAdminPagination(search), q: typeof search["q"] === "string" ? search["q"] : "" };
}

export function contentSearchUpdate(q: string) {
  return { q: q.trim().slice(0, 200), page: 1 };
}